import Footer from '../../Components/Footer';
import Navbar from '../../Components/Navbar';
import CategorySearchResults from '../../Components/Search bars/SearchByCategory';
import Landingpage from '../Home/Landingpage';


export default function SearchCategoryPage() {

    return(<>
    <Navbar />
    <Landingpage />
    <CategorySearchResults />
    <Footer />
    </>);
}